export default __webpack_public_path__ + "static/media/Info-icon.9519b651.svg";